import React, { useEffect } from "react"

import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"

const CodeArea = ({ content }) => {

  const copyFunction = () => {
    // Get the text field
    let copyText = document.getElementById("textArea");

  // Select the text field
  copyText.select();
  copyText.setSelectionRange(0, 99999); // For mobile devices

   // Copy the text inside the text field
  navigator.clipboard.writeText(copyText.value);
 
  }
  
  return (
    <Wrapper>
      <TextArea id="textArea" spellCheck={false}>{content.codeAreaField}</TextArea>
      <CopyButton id="copyButton" onClick={copyFunction}>Copy to Clipboard</CopyButton>
    </Wrapper>
  )
}
export default CodeArea

const CopyButton = styled.button`
  position: absolute;
  color: ${colors.primaryPurple};
  top: 0vw;
  right: 0vw;
  border-radius: 0vw 0.556vw 0vw 0.556vw;
  padding: 1.042vw;
  border: 0.069vw solid ${colors.primaryPurple};

  ${media.fullWidth} {
  border-radius: 0px 8px 0px 8px;
  padding: 15px;
  border: 1px solid ${colors.primaryPurple};
  }
  
  ${media.tablet} {
    border-radius: 0vw 0.781vw 0vw 0.781vw;
  padding: 1.465vw;
  border: 0.098vw solid ${colors.primaryPurple};
  }
  
  ${media.mobile} {
    border-radius: 1.869vw 0vw  0vw 1.869vw;
    padding: 1.869vw;
    border: 0.234vw solid ${colors.primaryPurple};
    height: max-content;
  }

  &:hover {
    background-color: ${colors.primaryPurple};
    color: ${colors.white};
  }
`
const TextArea = styled.textarea`
  resize: none;
  width: 63.333vw;
  min-height: 38.111vw;
  border-radius: 0.556vw;
  border: 0.069vw solid ${colors.primaryPurple};
  overflow: hidden;

  ${media.fullWidth} {
    width: 912px;
  min-height: 549px;
  border-radius: 8px;
  border: 1px solid ${colors.primaryPurple};
  }
  
  ${media.tablet} {
    width: 75vw;
  min-height: 65.613vw;
  border-radius: 0.781vw;
  border: 0.098vw solid ${colors.primaryPurple};
  }
  
  ${media.mobile} {
    width: 87.617vw;
    min-height: 165.271vw;
    border-radius: 1.869vw;
    border: 0.234vw solid ${colors.primaryPurple};
  }
`

const Wrapper = styled.div`
  position: relative;
`
